import { DestinationPlaceholder } from "@/routes/DestinationPlaceholder";

export function Money() {
  return <DestinationPlaceholder id="money" />;
}
